import type { AuthHeaders } from '../client'
import { request } from '../client'
import type { ClubDocument, Kit, KitRequest } from '../types'

export function getClub(auth: AuthHeaders): Promise<ClubDocument> {
  return request<ClubDocument>('/club', { auth })
}

export function listKits(auth: AuthHeaders): Promise<Kit[]> {
  return request<Kit[]>('/club/kits', { auth })
}

export function createKit(
  auth: AuthHeaders,
  body: KitRequest,
): Promise<Kit> {
  return request<Kit>('/club/kits', { method: 'POST', body, auth })
}

export function updateKit(
  auth: AuthHeaders,
  kitId: string,
  body: KitRequest,
): Promise<Kit> {
  return request<Kit>(`/club/kits/${encodeURIComponent(kitId)}`, {
    method: 'PATCH',
    body,
    auth,
  })
}

export function deleteKit(auth: AuthHeaders, kitId: string): Promise<void> {
  return request<void>(`/club/kits/${encodeURIComponent(kitId)}`, {
    method: 'DELETE',
    auth,
  })
}

export function setDefaultKit(
  auth: AuthHeaders,
  kitId: string | null,
): Promise<{ default_kit_id: string | null }> {
  return request<{ default_kit_id: string | null }>('/club/kits/default', {
    method: 'PATCH',
    body: { kit_id: kitId },
    auth,
  })
}
